// - history obj for BrowserRouter
// import { createBrowserHistory } from "history";
// export const history = createBrowserHistory();

// - history obj for HashRouter
import { createHashHistory } from "history";

export const history = createHashHistory();
